<div class="print-actions" *ngIf="showPrintActions">
  <div class="print-buttons">
    <button (click)="printPage()"
            class="btn btn-primary btn-lg">
      <clr-icon shape="printer"></clr-icon>
    </button>
  </div>
  <div class="back-buttons">
    <button (click)="doBackAndEdit()" class="btn btn-danger">НАЗАД І РЕДАГУВАТИ</button>
    <button (click)="doBackAndAdd()" class="btn btn-success">НОВИЙ ПАЦІЄНТ</button>
  </div>
  <div class="control-buttons">
    <button [ngClass]="{ 'btn-danger': inDesignMode, 'btn-primary': !inDesignMode }" class="btn btn-primary" (click)="toggleDesignMode()">
      Редагувати
      <clr-icon *ngIf="!inDesignMode" shape="pencil"></clr-icon>
      <clr-icon *ngIf="inDesignMode" shape="times"></clr-icon>
    </button>
    <button class="btn btn-primary" (click)="toggleSettings()">
      <clr-icon shape="cog"></clr-icon>
    </button>
  </div>
</div>

<div class="control-actions" *ngIf="showSettings">
  <div class="control-item logo-control">
    <div class="title">
      <strong>
        Розмір лого ({{ this.options.logoSize }}px) :
      </strong>
    </div>
    <div class="buttons">
      <button (click)="updateOptions('increase-logo-size')" class="btn btn-success btn-sm">
        +
      </button>
      <button (click)="updateOptions('decrease-logo-size')" class="btn btn-warning btn-sm">
        -
      </button>
    </div>
  </div>
  <div class="control-item title-control">
    <div class="title">
      <strong>
        Розмір титулу ({{ this.options.titleSize }}px):
      </strong>
    </div>
    <div class="buttons">
      <button (click)="updateOptions('increase-title-size')" class="btn btn-success btn-sm">
        +
      </button>
      <button (click)="updateOptions('decrease-title-size')" class="btn btn-warning btn-sm">
        -
      </button>
    </div>
  </div>
  <div class="control-item device-control">
    <div class="title">
      <strong>
        Розмір опису апарата ({{ this.options.deviceSize }}px):
      </strong>
    </div>

    <div class="buttons">
      <button (click)="updateOptions('increase-device-size')" class="btn btn-success btn-sm">
        +
      </button>
      <button (click)="updateOptions('decrease-device-size')" class="btn btn-warning btn-sm">
        -
      </button>
    </div>
  </div>
  <div class="control-item text-control">
    <div class="title">
      <strong>
        Розмір тексту ({{ this.options.fontSize }}px):
      </strong>
    </div>
    <div class="buttons">
      <button (click)="updateOptions('increase-font-size')" class="btn btn-success btn-sm">
        +
      </button>
      <button (click)="updateOptions('decrease-font-size')" class="btn btn-warning btn-sm">
        -
      </button>
    </div>
  </div>
  <div class="control-item text-control">
    <div class="title">
      <strong>
        Відступ ({{ this.options.lineHeight }}):
      </strong>
    </div>
    <div class="buttons">
      <button (click)="updateOptions('increase-line-height')" class="btn btn-success btn-sm">
        +
      </button>
      <button (click)="updateOptions('decrease-line-height')" class="btn btn-warning btn-sm">
        -
      </button>
    </div>
  </div>
  <div class="control-item title-control">
    <div class="title">
      <strong>
        Виділяти титул:
      </strong>
    </div>
    <div class="buttons">
      <button *ngIf="!this.options.strongTitles" (click)="updateOptions('toggle-strong-titles')" class="btn btn-success btn-sm">
        Так
      </button>
      <button *ngIf="this.options.strongTitles" (click)="updateOptions('toggle-strong-titles')" class="btn btn-warning btn-sm">
        Ні
      </button>
    </div>
  </div>
  <div class="control-item border-control">
    <div class="title">
      <strong>
        Підкреслювати значення:
      </strong>
    </div>
    <div class="buttons">
      <button *ngIf="!this.options.borderInValues" (click)="updateOptions('toggle-border-in-value')" class="btn btn-success btn-sm">
        Так
      </button>
      <button *ngIf="this.options.borderInValues" (click)="updateOptions('toggle-border-in-value')" class="btn btn-warning btn-sm">
        Ні
      </button>
    </div>
  </div>
  <div class="control-item border-control">
    <div class="title">
      <strong>
        Показувати пусті поля:
      </strong>
    </div>
    <div class="buttons">
      <button *ngIf="!this.options.showEmptyRows" (click)="updateOptions('toggle-empty-rows')" class="btn btn-success btn-sm">
        Так
      </button>
      <button *ngIf="this.options.showEmptyRows" (click)="updateOptions('toggle-empty-rows')" class="btn btn-warning btn-sm">
        Ні
      </button>
    </div>
  </div>
</div>
